import React from "react";

export const SectionPill = ({ children, ...rest }) => (
  <span className="tag-pill" {...rest}>{children}</span>
);

export const HeroBg = () => (
  <>
    <div className="tag-hero-grid" />
    <div className="tag-glow-left" />
    <div className="tag-glow-right" />
  </>
);

export const EyebrowPill = ({ children }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 8,
      background: "#111",
      border: "1px solid #222",
      borderRadius: 20,
      padding: "4px 14px",
      fontSize: 10,
      fontWeight: 600,
      color: "#aaa",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
    }}
  >
    <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#FF6575" }} />
    {children}
  </span>
);

export const CheckRow = ({ children }) => (
  <div style={{ display: "flex", gap: 9, alignItems: "baseline", fontSize: 13, color: "#aaa", fontWeight: 500, marginBottom: 10 }}>
    <span style={{ color: "#FF6575", fontWeight: 700 }}>✓</span>
    <span>{children}</span>
  </div>
);
